import DatabaseModel from './DatabaseModel.js';

var ItemClasificacion = Object.create(DatabaseModel);

ItemClasificacion.model = 'itemclasificacion';
ItemClasificacion.modelFront = 'itemclasificacion';

ItemClasificacion.importExcel = function(file, mode) {
    var self = this;
    var formData = new FormData();
    formData.append('file', file);
    if (mode) formData.append('mode', mode);
    return new Promise(function(resolve, reject) {
        var params = {
            url: self.server_movilidad + self.prefix + self.model + '/import?mode=' + (mode || 'UPSERT'),
            method: 'POST',
            crossDomain: true,
            dataType: 'json',
            data: formData
        };
        try {
            var session = JSON.parse(localStorage.getItem('session') || 'null');
            var token = session && (session.token || session.access_token);
            if (token) {
                params.headers = { Authorization: 'Bearer ' + token };
            }
        } catch (e) {}
        self.request.promise(params).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Cabecera Authorization desde la sesión de localStorage (helper interno). */
ItemClasificacion._authHeaders = function() {
    try {
        var session = JSON.parse(localStorage.getItem('session') || 'null');
        var token = session && (session.token || session.access_token);
        if (token) return { Authorization: 'Bearer ' + token };
    } catch (e) {}
    return {};
};

/** Lista ligera de formatos para revisión (paginada). Devuelve {list, totalCount}. */
ItemClasificacion.revisionFormatos = function(page, size) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/revision-formatos?page=' + (page || 0) + '&size=' + (size || 100),
            method: 'GET', crossDomain: true, dataType: 'json',
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body);
            else resolve({ list: (body && body.list) || [], totalCount: (body && body.totalCount) || 0 });
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Propuesta IA de clasificación para un formato. Devuelve el dto de la respuesta. */
ItemClasificacion.proponerClasificacion = function(codigo) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/revision-formatos/proponer',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: { codigo: codigo },
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Agrupa (IA) las características equivalentes de varios formatos y propone plantilla de ID. Devuelve {grupos, plantillaSugerida, ...}. */
ItemClasificacion.agruparCaracteristicas = function(codigos, tipo, subtipos, naturaleza) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/revision-formatos/agrupar-caracteristicas',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: { codigos: codigos, tipo: tipo || null, subtipos: subtipos || [], naturaleza: naturaleza || null },
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Lista (SIN IA) la unión de características de unos formatos. Devuelve [{nombre,label,descripcion,tipo}]. */
ItemClasificacion.formatoCaracteristicas = function(codigos) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/formato-caracteristicas',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: { codigos: codigos || [] },
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve((body && (body.list || (body.dto && body.dto.list))) || []);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Previsualiza la fusión de clasificaciones (no persiste). Devuelve el FusionPreviewDTO. */
ItemClasificacion.fusionarPreview = function(idDestino, idsFusionar) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/fusionar/preview',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: { idDestino: idDestino, idsFusionar: idsFusionar || [] },
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Aplica la fusión con las decisiones del usuario. Devuelve el resumen {formatosAnadidos,...}. */
ItemClasificacion.fusionarAplicar = function(payload) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/fusionar/aplicar',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: payload,
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Cancela la agrupación de características en curso (aborta también la IA en simecal-ai). */
ItemClasificacion.cancelarAgrupar = function() {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/revision-formatos/agrupar-cancelar',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: {},
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Crea las clasificaciones seleccionadas. Devuelve {creadas, errores}. */
ItemClasificacion.crearDesdePropuestas = function(propuestas) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/revision-formatos/crear',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: propuestas,
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Detección en lote: agrupa los formatos activos en clasificaciones nuevas vs cubiertas. */
/** Materias de los formatos pendientes (para el filtro de detección). Devuelve [{codigo,nombre,n}]. */
ItemClasificacion.materiasPendientes = function() {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/revision-formatos/materias-pendientes',
            method: 'GET', crossDomain: true, dataType: 'json',
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve((body && (body.list || (body.dto && body.dto.list))) || []);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

ItemClasificacion.detectarClasificaciones = function(materiasCodigos) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/revision-formatos/detectar',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: { materiasCodigos: materiasCodigos || [] },
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Crea el esqueleto de las clasificaciones elegidas en la detección. grupos = [{tipo,subtipos,naturaleza,materiasCodigos,codigosFormato}]. */
ItemClasificacion.crearDesdeDeteccion = function(grupos) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/revision-formatos/crear-deteccion',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: grupos,
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/**
 * Declara formatos pendientes en clasificaciones que ya existen (formatosUsados).
 * asignaciones = [{idClasificacion, codigosFormato:[...]}]. Con vincular=false, los quita.
 */
ItemClasificacion.vincularFormatos = function(asignaciones, vincular) {
    var self = this;
    var accion = vincular === false ? 'desvincular' : 'vincular';
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/revision-formatos/' + accion,
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: asignaciones,
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Cancela la creación automática de clasificaciones en curso. */
ItemClasificacion.cancelarCreacion = function() {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/revision-formatos/crear-cancelar',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: {},
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

// --- Condiciones de discriminación entre subtipos (revisión asistida por IA) ---

/**
 * Lanza la revisión. Con `id` revisa SOLO esa clasificación (la IA ve a las hermanas como
 * contexto). La propuesta llega por SSE (accion="discriminantes").
 */
ItemClasificacion.revisarDiscriminantes = function(codigo, id) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/discriminantes/revisar',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: { codigo: codigo, id: id || null },
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Cancela la revisión en curso (aborta también la llamada a la IA). */
ItemClasificacion.cancelarDiscriminantes = function() {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/discriminantes/cancelar',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: {},
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/**
 * Empates registrados (varias clasificaciones cumplieron a la vez). Con `id` solo los que
 * implican a esa clasificación, para su ficha.
 */
ItemClasificacion.empatesDiscriminantes = function(codigo, id) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/discriminantes/empates?codigo='
                + encodeURIComponent(codigo || '') + '&id=' + encodeURIComponent(id || ''),
            method: 'GET', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Opciones declaradas aplicables a una clasificación, para editar sus condiciones a mano. */
ItemClasificacion.catalogoDiscriminantes = function(id) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/discriminantes/catalogo?id=' + encodeURIComponent(id || ''),
            method: 'GET', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Cuántos items podrían cambiar si se tocan las condiciones de esta clasificación. */
ItemClasificacion.afectadosDiscriminantes = function(id) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/discriminantes/afectados?id=' + encodeURIComponent(id || ''),
            method: 'GET', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Cancela la reclasificación en curso (se detiene entre items, no a mitad de uno). */
ItemClasificacion.cancelarReclasificacionDiscriminantes = function() {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/discriminantes/reclasificar-cancelar',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: {},
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Estado de la reclasificación, para recuperar el contador al volver a la ficha. */
ItemClasificacion.estadoReclasificacionDiscriminantes = function() {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/discriminantes/reclasificar-estado',
            method: 'GET', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Lanza en segundo plano la reclasificación de los items del tipo (re-sync completo). */
ItemClasificacion.reclasificarPorDiscriminantes = function(id) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/discriminantes/reclasificar',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: { id: id },
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Guarda las condiciones aceptadas. propuestas = [{clasificacionId, subtipos, condiciones:[...]}]. */
ItemClasificacion.confirmarDiscriminantes = function(propuestas) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/discriminantes/confirmar',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: propuestas,
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/**
 * Calcula por detrás las propuestas de características de varias clasificaciones a la vez.
 * Devuelve enseguida; el avance va por el canal SSE «sugerencia-masiva».
 */
ItemClasificacion.sugerenciaMasiva = function(idsClasificacion) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/sugerencia-masiva',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: { idsClasificacion: idsClasificacion || [] },
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Pide parar la tanda; lo que ya se esté calculando termina. */
ItemClasificacion.cancelarSugerenciaMasiva = function() {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/sugerencia-masiva/cancelar',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: {},
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Por dónde va la tanda. Sirve de respaldo si el SSE no está vivo o se conectó tarde. */
ItemClasificacion.estadoSugerenciaMasiva = function() {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/sugerencia-masiva/estado',
            method: 'GET', crossDomain: true, dataType: 'json',
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/**
 * Propuesta ya calculada de una clasificación, o null si no hay.
 * Viene con `caducada: true` si los formatos cambiaron después de calcularla.
 */
ItemClasificacion.sugerenciaCaracteristicas = function(idClasificacion) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/' + idClasificacion + '/sugerencia-caracteristicas',
            method: 'GET', crossDomain: true, dataType: 'json',
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

/** Descarta la propuesta guardada: tras aplicarla, o para forzar que se recalcule. */
ItemClasificacion.descartarSugerencia = function(idClasificacion) {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/' + idClasificacion + '/sugerencia-caracteristicas/descartar',
            method: 'POST', crossDomain: true, dataType: 'json',
            contentType: 'application/json',
            data: {},
            headers: self._authHeaders()
        }).then(function(res) {
            var body = res.data;
            if (body && body.error) reject(body); else resolve(body && body.dto ? body.dto : body);
        }).catch(function(e) {
            try { reject(JSON.parse(e.xhr.response).error || e.xhr.response); } catch (ex) { reject(e); }
        });
    });
};

export default ItemClasificacion;
